"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Greta = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
class Greta extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.GRETA,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L31',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.opgArrow().text('ACTIVATE THE BELOW ABILITY');
                    b.br.br;
                    b.tr(1).colon().megacredits(4).asterix();
                    b.br;
                }),
                description: 'When you take an action that raises your terraform rating THIS GENERATION (max 10 times), gain 4 M€.',
            },
        });
        this.isDisabled = false;
        this.opgActionIsActive = false;
        this.effectTriggerCount = 0;
    }
    play() {
        return undefined;
    }
    canAct() {
        return this.isDisabled === false;
    }
    action() {
        this.opgActionIsActive = true;
        this.isDisabled = true;
        return undefined;
    }
    onTRIncrease(player) {
        if (this.opgActionIsActive === false)
            return;
        if (this.effectTriggerCount === 10)
            return;
        this.effectTriggerCount++;
        const remainingUses = 10 - this.effectTriggerCount;
        player.game.log('${0} triggered ${1} effect (${2}/10 remaining)', (b) => b.player(player).card(this).number(remainingUses));
        player.addResource(Resources_1.Resources.MEGACREDITS, 4, { log: true });
        return undefined;
    }
}
exports.Greta = Greta;
//# sourceMappingURL=Greta.js.map